import axios from 'axios';
import { fromEvent, interval, merge, Subject } from 'rxjs';
import { buffer, filter, first } from 'rxjs/operators';

import type { ClickStreamEvent } from '../utilities/moMetrics/clickStreamEvent';
import { buildUrl } from './helpers';
import { RecordAnalytics } from './resources';

const EVENT_BATCH_INTERVAL_MS = 3000;

const submittedQueue = new Subject<ClickStreamEvent[]>();
const eventQueue = new Subject<ClickStreamEvent>();

const intervalTrigger = interval(EVENT_BATCH_INTERVAL_MS);
const manualTrigger = new Subject<void>();
const unloadTrigger = fromEvent(document, 'pagehide');

const eventObservable = eventQueue.pipe(
  buffer(merge(intervalTrigger, manualTrigger, unloadTrigger)),
  filter(b => !!b.length)
);

const AnalyticsApi = {
  queue: (event: ClickStreamEvent) => {
    eventQueue.next(event);
  },
  queueAndSendAll: (event: ClickStreamEvent) => {
    const promise = new Promise(resolve => {
      submittedQueue.pipe(first()).subscribe(resolve);
    });
    eventQueue.next(event);
    manualTrigger.next();
    return promise;
  },
  recordNow: (analyticsEvents: ClickStreamEvent[]): Promise<any> =>
    axios.post(buildUrl(RecordAnalytics, ''), analyticsEvents)
};

eventObservable.subscribe({
  next: async event => {
    try {
      await AnalyticsApi.recordNow(event);
      submittedQueue.next(event);
    } catch (_error) {
      submittedQueue.next(null);
    }
  }
});

export default AnalyticsApi;
